(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nn-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nn-delivery-estimate')) {
    class NakedNatesDelivery extends HTMLElement {
      static calendarDate(now = new Date()) {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Chicago',
          year: 'numeric',
          month: 'numeric',
          day: 'numeric'
        }).formatToParts(now);
        const value = (type) => Number(parts.find((part) => part.type === type).value);
        return new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
      }

      static addDays(date, days) {
        const result = new Date(date);
        result.setUTCDate(result.getUTCDate() + days);
        return result;
      }

      static dateKey(date) {
        return date.toISOString().slice(0, 10);
      }

      static holidays(year) {
        const dates = new Set();
        const add = (date) => dates.add(this.dateKey(date));
        const fixed = (month, day) => {
          const date = new Date(Date.UTC(year, month - 1, day, 12));
          add(date);
          if (date.getUTCDay() === 0) add(this.addDays(date, 1));
        };
        const weekday = (month, day, occurrence) => {
          const first = new Date(Date.UTC(year, month - 1, 1, 12));
          add(this.addDays(first, (day - first.getUTCDay() + 7) % 7 + (occurrence - 1) * 7));
        };
        fixed(1, 1);
        weekday(1, 1, 3);
        weekday(2, 1, 3);
        const mayLast = new Date(Date.UTC(year, 4, 31, 12));
        add(this.addDays(mayLast, -((mayLast.getUTCDay() - 1 + 7) % 7)));
        fixed(6, 19);
        fixed(7, 4);
        weekday(9, 1, 1);
        weekday(10, 1, 2);
        fixed(11, 11);
        weekday(11, 4, 4);
        fixed(12, 25);
        return dates;
      }

      static isTransitDay(date) {
        return date.getUTCDay() !== 0 && date.getUTCDay() !== 6 &&
          !this.holidays(date.getUTCFullYear()).has(this.dateKey(date));
      }

      static arrivalDate(shipDate, transitDays) {
        let date = new Date(shipDate);
        while (!this.isTransitDay(date)) date = this.addDays(date, 1);
        let remaining = transitDays;
        while (remaining > 0) {
          date = this.addDays(date, 1);
          if (this.isTransitDay(date)) remaining -= 1;
        }
        return date;
      }

      static ranges(now = new Date()) {
        const today = this.calendarDate(now);
        const ship = [this.addDays(today, 7), this.addDays(today, 10)];
        return {
          ship,
          ground: [this.arrivalDate(ship[0], 2), this.arrivalDate(ship[1], 5)],
          priority: [this.arrivalDate(ship[0], 2), this.arrivalDate(ship[1], 3)]
        };
      }

      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) this.updateDates();
        });
        this.refreshDates = () => this.updateDates();
        document.addEventListener('visibilitychange', this.refreshDates);
        this.refreshTimer = window.setInterval(this.refreshDates, 60000);
      }

      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.refreshDates);
        window.clearInterval(this.refreshTimer);
      }

      updateDates() {
        const dateList = this.querySelector('[data-nn-dates]');
        if (!dateList) return;
        try {
          const now = new Date();
          const today = NakedNatesDelivery.dateKey(NakedNatesDelivery.calendarDate(now));
          if (today === this.lastDate) return;
          const ranges = NakedNatesDelivery.ranges(now);
          const options = { month: 'short', day: 'numeric', timeZone: 'UTC' };
          if (ranges.ground[1].getUTCFullYear() !== NakedNatesDelivery.calendarDate(now).getUTCFullYear()) {
            options.year = 'numeric';
          }
          let formatter;
          try {
            formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en', options);
          } catch {
            formatter = new Intl.DateTimeFormat('en', options);
          }
          this.querySelectorAll('[data-nn-range]').forEach((node) => {
            const range = ranges[node.dataset.nnRange];
            node.textContent = formatter.formatRange(range[0], range[1]);
          });
          dateList.hidden = false;
          this.lastDate = today;
        } catch {
          dateList.hidden = true;
        }
      }
    }

    customElements.define('nn-delivery-estimate', NakedNatesDelivery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nn-home-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('#MainContent');
    if (!root || !root.querySelector('.nn-sun-hero') || root.dataset.nnMotionReady) return;
    root.dataset.nnMotionReady = 'true';
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const seen = new WeakSet();
    const pending = new Set();
    const active = new Map();
    const selectors = [
      '.nn-sun-featured__heading',
      '.nn-sun-featured__card',
      '.nn-sun-featured__paths',
      '.sun-story__portrait-wrap',
      '.sun-story__content',
      '.sun-story__symbol',
      '.nn-sun-reviews__wrap'
    ].join(',');
    const reveal = (element) => {
      if (seen.has(element)) return;
      seen.add(element);
      pending.delete(element);
      observer.unobserve(element);
      element.classList.remove('nn-motion-pending');
      if (preference.matches || element.contains(document.activeElement)) return;
      const bounds = element.getBoundingClientRect();
      if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
      const isCard = element.matches('.nn-sun-featured__card');
      const index = isCard ? Array.from(element.parentElement.children).indexOf(element) : 0;
      const fadeOnly = element.matches('.sun-story__portrait-wrap, .sun-story__symbol, .nn-sun-reviews__wrap');
      try {
        const animation = element.animate([
          { opacity: 0, translate: fadeOnly ? '0 0' : '0 20px' },
          { opacity: 1, translate: '0 0' }
        ], {
          duration: 900,
          delay: Math.min(index, 2) * 100,
          easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
          fill: 'backwards'
        });
        active.set(element, animation);
        const clear = () => active.delete(element);
        animation.addEventListener('finish', clear, { once: true });
        animation.addEventListener('cancel', clear, { once: true });
      } catch (_) {}
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, { threshold: 0.04, rootMargin: '0px 0px -8px 0px' });
    const scan = (scope) => {
      scope.querySelectorAll(selectors).forEach((element) => {
        if (seen.has(element) || pending.has(element)) return;
        const bounds = element.getBoundingClientRect();
        if (preference.matches || bounds.top < window.innerHeight) {
          seen.add(element);
          return;
        }
        pending.add(element);
        observer.observe(element);
        element.classList.add('nn-motion-pending');
      });
    };
    const finishAll = () => {
      observer.disconnect();
      pending.forEach((element) => {
        element.classList.remove('nn-motion-pending');
        seen.add(element);
      });
      pending.clear();
      active.forEach((animation) => animation.cancel());
      active.clear();
    };
    root.addEventListener('focusin', (event) => {
      pending.forEach((element) => {
        if (element.contains(event.target)) reveal(element);
      });
      active.forEach((animation, element) => {
        if (element.contains(event.target)) animation.cancel();
      });
    });
    preference.addEventListener('change', () => {
      if (preference.matches) finishAll();
    });
    document.addEventListener('shopify:section:load', (event) => {
      if (root.contains(event.target)) scan(event.target);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      pending.forEach((element) => {
        if (event.target.contains(element)) {
          observer.unobserve(element);
          element.classList.remove('nn-motion-pending');
          pending.delete(element);
        }
      });
      active.forEach((animation, element) => {
        if (event.target.contains(element)) animation.cancel();
      });
    });
    window.addEventListener('pagehide', finishAll);
    scan(root);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nn-legacy-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nn-legacy-options')){
  customElements.define('nn-legacy-options',class extends HTMLElement{
    connectedCallback(){
      if(this.validate)return;
      this.validate=event=>{
        if(event.target.id!==this.dataset.form)return;
        if(!event.target.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
      };
      document.addEventListener('submit',this.validate,true);
    }
    disconnectedCallback(){document.removeEventListener('submit',this.validate,true);this.validate=null;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nn-preview-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nn-studio-options')){
  customElements.define('nn-studio-options',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.styleInput=this.querySelector('[data-style]');
      this.letters=this.querySelector('[data-letters]');
      this.confirm=this.querySelector('[data-confirm]');
      this.changeStyle=()=>{
        this.querySelectorAll('[data-length-panel]').forEach(panel=>{
          const active=panel.dataset.lengthPanel===this.styleInput.value;
          panel.hidden=!active;panel.querySelector('select').disabled=!active;
        });
      };
      if(this.styleInput)this.styleInput.addEventListener('change',this.changeStyle);
      this.changeStyle();
      if(this.letters)this.letters.addEventListener('input',()=>{
        this.letters.value=this.letters.value.toUpperCase();
        const valid=new RegExp('^[A-Z]{'+this.letters.dataset.min+','+this.letters.dataset.max+'}$').test(this.letters.value);
        this.letters.setCustomValidity(valid?'':this.dataset.letterError);
        this.querySelector('[data-letter-preview]').textContent=this.letters.value;
        this.confirm.checked=false;
      });
      this.validate=event=>{
        if(event.target.id!==this.dataset.form)return;
        this.changeStyle();
        if(!event.target.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
      };
      document.addEventListener('submit',this.validate,true);
    }
    disconnectedCallback(){document.removeEventListener('submit',this.validate,true);this.initialized=false;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nn-product-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nn-product-video')) {
    customElements.define('nn-product-video', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.controls = false;
        this.video.playsInline = true;
        this.video.pause();
        this.visible = false;
        this.userPaused = false;
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
          if (!this.visible) this.userPaused = false;
          this.syncPlayback();
        }, { threshold: [0, 0.5] });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.addEventListener('click', () => this.togglePlayback(), options);
        this.addEventListener('keydown', (event) => {
          if (event.key !== ' ' && event.key !== 'Enter') return;
          event.preventDefault();
          this.togglePlayback();
        }, options);
        this.video.addEventListener('play', () => this.setAttribute('aria-label', this.dataset.pauseLabel), options);
        this.video.addEventListener('pause', () => this.setAttribute('aria-label', this.dataset.playLabel), options);
      }
      syncPlayback() {
        if (!this.video) return;
        if (!this.visible || document.hidden || this.userPaused) {
          this.video.pause();
          return;
        }
        this.video.play().catch(() => this.setAttribute('aria-label', this.dataset.playLabel));
      }
      togglePlayback() {
        this.userPaused = !this.video.paused;
        this.syncPlayback();
      }
      disconnectedCallback() {
        this.video?.pause();
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nn-studio-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nn-studio-options')){
  customElements.define('nn-studio-options',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.styleInput=this.querySelector('[data-style]');
      this.letters=this.querySelector('[data-letters]');
      this.confirm=this.querySelector('[data-confirm]');
      this.changeStyle=()=>{
        this.querySelectorAll('[data-length-panel]').forEach(panel=>{
          const active=panel.dataset.lengthPanel===this.styleInput.value;
          panel.hidden=!active;panel.querySelector('select').disabled=!active;
        });
      };
      this.styleInput.addEventListener('change',this.changeStyle);
      this.changeStyle();
      if(this.letters)this.letters.addEventListener('input',()=>{
        this.letters.value=this.letters.value.toUpperCase();
        const valid=new RegExp('^[A-Z]{'+this.letters.dataset.min+','+this.letters.dataset.max+'}$').test(this.letters.value);
        this.letters.setCustomValidity(valid?'':this.dataset.letterError);
        this.querySelector('[data-letter-preview]').textContent=this.letters.value;
        this.confirm.checked=false;
      });
      this.validate=event=>{
        if(event.target.id!==this.dataset.form)return;
        this.changeStyle();
        if(!event.target.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
      };
      document.addEventListener('submit',this.validate,true);
    }
    disconnectedCallback(){document.removeEventListener('submit',this.validate,true);this.initialized=false;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
